export default __webpack_public_path__ + "static/media/Bandit's Vambraces of the Grasslands.1f6f9c40.jpg";